export default "__VITE_ASSET__200b5041__"